// ** Icons Import
import { Heart } from 'react-feather'

const Footer = () => {
  return (
    <p className='clearfix mb-0'>
      <span className='float-md-start d-block d-md-inline-block mt-25'>
      </span>
      <span className='float-md-end d-md-block'>
          RAISEGEN™ © {new Date().getFullYear()}{' '}
     
      </span>
    </p>
  )
}

export default Footer
